module.exports = __webpack_public_path__ + "img/gibraltar.83995872.svg";